import { DefaultLayout } from "~/layouts/DefaultLayout";
import { CategoryList } from "~/components/CategoryList";
import { MetaHeader } from "~/components/MetaHeader";
import { PurposeImages } from "~/constants";

const Purpose: React.VFC = () => {
    return (
        <>
            <MetaHeader title={"目的検索 - 福岡カフェ日記 | 福岡最大級のカフェメディア"} description={"「目的別検索 | 福岡カフェ日記」では、あなたのカフェ訪問の目的に完璧にマッチするスポットを見つけることができます。初デートにぴったりなロマンティックな雰囲気のカフェ、友達との楽しい時間を過ごせるカジュアルなカフェ、朝のひとときを豊かにする絶品モーニングを提供するカフェなど、目的に応じたカフェを簡単に探すことができます。各カテゴリには、訪問目的を考慮したおすすめのカフェがリストアップされており、詳細なメニュー情報、アクセス方法、来店者のレビューも合わせてチェックできます。福岡でのカフェ探しをもっと楽しく、もっと便利に。あなたの次のカフェ訪問は、目的に合わせた最適な選択から始めてみませんか？"} />
            <DefaultLayout>
                <h1 className="category_title">目的から選ぶ</h1>
                <CategoryList categoryList={PurposeImages} />
            </DefaultLayout>
        </>
    );
};

export default Purpose;